import { Route, Routes, Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material";

import HcorzAlert from "../layout/HcorzAlert.jsx";
import HcorzDashboard from "../layout/HcorzDashboard.jsx";

// Landing Pages
import LandingHome from "../landing/LandingHome.jsx";
import LandingQuienesSomos from "../landing/LandingQuienesSomos.jsx";
import LandingSSMA from "../landing/LandingSSMA.jsx";
import LandingServicios from "../landing/LandingServicios.jsx";
import LandingExperiencia from "../landing/LandingExperiencia.jsx";
import LandingContacto from "../landing/LandingContacto.jsx";

import FrmCalibracion from "../../components/calibracion/FrmCalibracion";
import FrmImportarCalibracion from "../../components/calibracion/FrmImportarCalibracion";
import FrmRegistroCalibracion from "../../components/calibracion/FrmRegistroCalibracion";
import InventarioEquipos from "../../components/calibracion/InventarioEquipos";
import CalendarioCalibraciones from "../../components/calibracion/CalendarioCalibraciones";
import FrmTrabajador from "../../components/rrhh/FrmTrabajador";
import UsuariosTable from "../../components/configuracion/Usuarios/UsuariosTable";
import RolesTable from "../../components/configuracion/Roles/RolesTable";
import ConfigAccesos from "../../components/configuracion/Accesos/ConfigAccesos";
import ConfigApi from "../../components/configuracion/Api/ConfigApi";
import Login from "../login/Login.jsx";

import { routeLogin, routeDashboard, routeCalibracion, routeCargaCalibracion, routeUsuarios, routeRoles, routeTrabajador, routeBase, routeAccessControl } from "../../settings/routeConfig";
import { useConfiguracion } from "../../context/System/ConfiguracionContext";
import { useSesion } from "../../context/System/SesionContext";
import ErrorBoundary from "../utils/ErrorBoundary.jsx";

export default function HcorzPage() {
  const { theme } = useConfiguracion();
  const { usuarioEnSesion } = useSesion();

  return (
    <ThemeProvider theme={theme}>
      <div className="hcorz-page">
        <div className="content">
          <ErrorBoundary>
            <Routes future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              {/* Rutas Privadas */}
              <Route path={routeCalibracion} element={usuarioEnSesion ? <HcorzDashboard title='Gestión de Mantto - Calibración' children={<FrmCalibracion />} /> : <Login />} />
              <Route path={routeCargaCalibracion} element={usuarioEnSesion ? <HcorzDashboard title='Gestión de Mantto - Carga de Calibración' children={<FrmImportarCalibracion />} /> : <Login />} />
              <Route path={routeUsuarios} element={usuarioEnSesion ? <HcorzDashboard title='Configuración - Usuarios' children={<UsuariosTable />} /> : <Login />} />
              <Route path={routeRoles} element={usuarioEnSesion ? <HcorzDashboard title='Configuración - Roles' children={<RolesTable />} /> : <Login />} />
              <Route path={routeAccessControl} element={usuarioEnSesion ? <HcorzDashboard title='Configuración - Accesos' children={<ConfigAccesos />} /> : <Login />} />
              <Route path="/config-api" element={usuarioEnSesion ? <HcorzDashboard title='Sistemas - Configuración API' children={<ConfigApi />} /> : <Login />} />
              <Route path="/regi-calibracion" element={usuarioEnSesion ? <HcorzDashboard title='Gestión de Mantto - Registro de Calibración' children={<FrmRegistroCalibracion />} /> : <Login />} />
              <Route path="/inventario-equipos" element={usuarioEnSesion ? <HcorzDashboard title='Gestión de Mantto - Inventario de Equipos' children={<InventarioEquipos />} /> : <Login />} />
              <Route path="/prog-calibracion" element={usuarioEnSesion ? <HcorzDashboard title='Gestión de Mantto - Programación de Calibraciones' children={<CalendarioCalibraciones />} /> : <Login />} />
              <Route path="/MEN025/*" element={<Navigate to="/MEN030" replace />} />
              <Route path={routeTrabajador} element={usuarioEnSesion ? <HcorzDashboard title='RRHH - Personal' children={<FrmTrabajador />} /> : <Login />} />
              <Route path={routeDashboard} element={usuarioEnSesion ? <HcorzDashboard title='Resumen' /> : <Login />} />

              {/* Rutas Públicas */}
              <Route path={routeLogin} element={<Login />} />

              {/* Landing Page Routes */}
              <Route path={routeBase} element={<LandingHome />} />
              <Route path="/quienes-somos" element={<LandingQuienesSomos />} />
              <Route path="/ssma" element={<LandingSSMA />} />
              <Route path="/servicios" element={<LandingServicios />} />
              <Route path="/experiencia" element={<LandingExperiencia />} />
              <Route path="/contacto" element={<LandingContacto />} />

            </Routes>
          </ErrorBoundary>
        </div>
      </div>
      <HcorzAlert />
    </ThemeProvider>
  );
}